module.exports = __webpack_public_path__ + "img/21_7.acd95480.png";